import { getRandomString } from "@/util/random-string";
import { v4 as uuidv4 } from "uuid";
import { isObject } from "@/util/objects";
import { pipe } from "fp-ts/function";
import * as t from "io-ts";
import { fold } from "fp-ts/Either";

export function renderRepeaterVariables(newValue: unknown, totalItems: number) {
  if (!newValue) {
    return {};
  }

  const maybeDefaultValue = pipe(
    newValue,
    t.record(t.string, t.unknown).decode,
    fold(
      () => null,
      unknownDefault => unknownDefault
    )
  );

  if (!maybeDefaultValue) {
    return {};
  }

  const returnValue: Record<string, unknown> = {};

  Object.keys(maybeDefaultValue).forEach(key => {
    let value = maybeDefaultValue[key];

    if (typeof value === "string") {
      value = value
        .replace("{random_string}", getRandomString())
        .replace("{uuid}", uuidv4())
        .replace("{index}", `${totalItems}`);
    }

    if (isObject(value)) {
      value = renderRepeaterVariables(value, totalItems);
    }

    returnValue[key] = value;
  });

  return returnValue;
}
